"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightControlsEvents = void 0;
var LightControlsEvents;
(function (LightControlsEvents) {
    LightControlsEvents["UPDATED"] = "updated";
})(LightControlsEvents = exports.LightControlsEvents || (exports.LightControlsEvents = {}));
;
